import React from "react";
import { FaCalendarCheck, FaPhoneAlt, FaRupeeSign, FaWhatsapp } from "react-icons/fa";
import { buildBanquetWhatsappLink, WHATSAPP_NUMBER } from "../../utils/banquetWhatsapp.js";

export default function WhatsAppInquiryBar({ banquet, selectedDate, selectedSlot, pageUrl }) {
  const href = buildBanquetWhatsappLink({
    banquet,
    selectedDate,
    selectedSlot,
    pageUrl,
  });

  return (
    <div className="sticky bottom-0 z-40 border-t border-amber-200 bg-white/95 px-2 py-2 shadow-[0_-20px_60px_-35px_rgba(15,23,42,0.65)] backdrop-blur supports-[padding:max(0px)]:pb-[max(0.5rem,env(safe-area-inset-bottom))] sm:px-4 sm:py-3">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 sm:gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="hidden min-w-0 sm:block">
          <p className="text-sm font-black text-slate-950">Lock the best date-wise quote</p>
          <p className="text-sm font-medium text-slate-600">
            Share your date and get current pricing, visit support, and availability.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-4 lg:w-auto">
          <a
            href={`tel:+${WHATSAPP_NUMBER}`}
            className="inline-flex min-h-[48px] min-w-0 items-center justify-center gap-2 rounded-xl bg-slate-950 px-2 py-2 text-center text-xs font-black leading-tight text-white sm:min-h-[52px] sm:rounded-2xl sm:px-4 sm:text-sm"
          >
            <FaPhoneAlt className="shrink-0 text-sm" />
            <span className="truncate">Call Now</span>
          </a>
          <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="inline-flex min-h-[48px] min-w-0 items-center justify-center gap-2 rounded-xl bg-[#25D366] px-2 py-2 text-center text-xs font-black leading-tight text-white shadow-[0_20px_40px_-18px_rgba(37,211,102,0.8)] transition hover:brightness-95 sm:min-h-[52px] sm:rounded-2xl sm:px-4 sm:text-sm"
          >
            <FaWhatsapp className="shrink-0 text-base" />
            <span className="truncate">WhatsApp Now</span>
          </a>
          <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="inline-flex min-h-[48px] min-w-0 items-center justify-center gap-2 rounded-xl border border-amber-200 bg-amber-50 px-2 py-2 text-center text-xs font-black leading-tight text-[#85580f] sm:min-h-[52px] sm:rounded-2xl sm:px-4 sm:text-sm"
          >
            <FaCalendarCheck className="shrink-0 text-sm" />
            <span className="truncate">Book Site Visit</span>
          </a>
          <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="inline-flex min-h-[48px] min-w-0 items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-2 py-2 text-center text-xs font-black leading-tight text-slate-800 sm:min-h-[52px] sm:rounded-2xl sm:px-4 sm:text-sm"
          >
            <FaRupeeSign className="shrink-0 text-sm" />
            <span className="truncate">Check Live Offer</span>
          </a>
        </div>
      </div>
    </div>
  );
}
